import Component from "@ember/component"
import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import _ from "lodash"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

export default class AdminVersionBox extends Component {
  @service("ember-store") store

  @service rpc

  @computed("model.id", "model.type", "model.attributes.version")
  get documentVersions() {
    let modelType = get(this, "model.type")
    let id = get(this, "model.id")
    let promise = get(this, "rpc")["GET_DOCUMENT_VERSIONS_FOR"](modelType, id)
    return ObjectPromiseProxy.create({
      promise: promise,
    })
  }

  @computed("documentVersions.data")
  get documentVersionsGroupedByDate() {
    let data = get(this, "documentVersions.data")
    return _.chain(data)
      .reverse()
      .map((datum) => {
        datum.attributes.date = datum.attributes.insertedAt.slice(0, 10)
        return datum
      })
      .groupBy((datum) => datum.attributes.date)
      .map((dates, date) => {
        return [{ dateString: date }, dates]
      })
      .flattenDeep()
      .value()
  }

  @computed("currentVersion", "model.attributes.version")
  get versionSelected() {
    return get(this, "currentVersion") === "master"
      ? get(this, "model.attributes.version")
      : get(this, "currentVersion")
  }
}
